import immutableStore from 'utils/immutableStore';
import alt from 'components/Dispatcher';
import {Record, Map} from 'immutable';
import TriggerTrend, {TrendType} from 'records/TriggerTrend';
import periodOptions from 'components/triggers/trigger-actions/periodOptions';
import subPeriodOptions from 'components/triggers/trigger-actions/subPeriodOptions';
import UnsavedTriggerActions from 'actions/triggers/UnsavedTriggerActions';
import {TriggerActionType} from 'records/TriggerRuleAction';

const defaultTrend = new TriggerTrend({
  inequalityType: 'EQUAL_TO',
  threshold: 40,
  period: periodOptions.get(1).value,
  subPeriod: subPeriodOptions.get(0).value,
  antiRuleId: undefined,
  trendType: TrendType.COUNT_OF_TIMES,
});

const defaultSendState = Map({
  [TriggerActionType.FOLDER]: true,
  [TriggerActionType.DASHBOARD]: false,
  [TriggerActionType.EMAIL]: false,
  [TriggerActionType.SLACK]: false,
});

@immutableStore
class UnsavedTriggerStore {
  constructor() {
    this.state = Record({
      trend: defaultTrend,
      sendTo: defaultSendState,
      // Actions are either events or trends
      actionType: null,
      // Amount of time in seconds to throttle notifications by
      // (No effect for trends)
      damping: 0,
    })();
    this.bindActions(UnsavedTriggerActions);
  }

  reset() {
    this.setState({
      trend: defaultTrend,
      sendTo: defaultSendState,
      actionType: null,
      damping: 0,
    });
  }

  setSendToInbox(sendToInbox) {
    this.setState({
      sendTo: this.state.sendTo.set(TriggerActionType.FOLDER, sendToInbox),
    });
  }

  setSendToEmail(sendToEmail) {
    this.setState({
      sendTo: this.state.sendTo.set(TriggerActionType.EMAIL, sendToEmail),
    });
  }

  setSendToSlack(sendToSlack) {
    this.setState({
      sendTo: this.state.sendTo.set(TriggerActionType.SLACK, sendToSlack),
    });
  }

  setDamping(damping) {
    this.setState({damping});
  }

  setActionType(actionType) {
    this.setState({actionType});
  }

  setTrend(trend) {
    this.setState({trend});
  }

  setInequalityType(inequalityType) {
    this.setState({trend: this.state.trend.merge({inequalityType})});
  }

  setThreshold(threshold) {
    this.setState({trend: this.state.trend.merge({threshold})});
  }

  setPeriod(period) {
    this.setState({trend: this.state.trend.merge({period})});
  }

  setSubPeriod(subPeriod) {
    this.setState({trend: this.state.trend.merge({subPeriod})});
  }

  setAntiRuleId(antiRuleId) {
    this.setState({trend: this.state.trend.merge({antiRuleId})});
  }

  setTrendType([trendType, usingDefault]) {
    if (usingDefault) {
      // continue switching between defaults for each type
      const values =
        trendType === TrendType.PERCENTAGE_OF_TIMES
          ? {
              trendType,
              threshold: 'GREATER_THAN_OR_EQUAL_TO',
              subPeriod: 10,
            }
          : {
              trendType,
              inequalityType: 'EQUAL_TO',
              threshold: 40,
              subPeriod: subPeriodOptions.get(0).value,
            };
      this.setState({trend: this.state.trend.merge(values)});
    } else {
      this.setState({trend: this.state.trend.merge({trendType})});
    }
  }
}

export default alt.createStore(UnsavedTriggerStore);
